import React, { useState } from 'react'
import { saveEmailToSupabase } from '../services/emailService'
import { FaCheckCircle, FaLock } from 'react-icons/fa'

const Newsletter = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [emailError, setEmailError] = useState('')
  const [saveSuccess, setSaveSuccess] = useState(false)
  return (
    <section className='py-8 md:py-16 bg-surface bg-opacity-30 rounded-lg p-6 md:p-10'>
      <div className='text-center mb-8'>
        <h2 className='text-xl md:text-3xl font-bold mb-4 text-text-primary'>
          Suscríbete a Nuestra Newsletter y no Te Pierdas Ninguna Actualización
          Importante sobre Códigos CNAE y Epígrafes IAE
        </h2>
        <p className='text-text-secondary font-medium mb-6 max-w-2xl mx-auto'>
          Mantente al día con los cambios fiscales y legislativos que afectan a
          tu actividad empresarial. Suscríbete a nuestro boletín especializado y
          sé el primero en conocer:
        </p>
        <div className='flex flex-col items-start text-left max-w-xl mx-auto mb-6'>
          <div className='flex items-center mb-2'>
            <FaCheckCircle className='text-primary mr-2' />
            <span className='text-text-secondary'>
              Actualizaciones oficiales de epígrafes IAE y códigos CNAE 2025
            </span>
          </div>
          <div className='flex items-center mb-2'>
            <FaCheckCircle className='text-primary mr-2' />
            <span className='text-text-secondary'>
              Cambios normativos que afectan a tus obligaciones fiscales
            </span>
          </div>
          <div className='flex items-center mb-2'>
            <FaCheckCircle className='text-primary mr-2' />
            <span className='text-text-secondary'>
              Nuevas funcionalidades de nuestro conversor especializado
            </span>
          </div>
          <div className='flex items-center mb-2'>
            <FaCheckCircle className='text-primary mr-2' />
            <span className='text-text-secondary'>
              Guías prácticas para la correcta clasificación de tu actividad
              económica
            </span>
          </div>
        </div>
      </div>

      <div className='max-w-md mx-auto'>
        <form
          onSubmit={async (e) => {
            e.preventDefault()
            setEmailError('')
            setSaveSuccess(false)

            const email = e.target.email.value
            const termsAccepted = e.target.terms.checked

            // Validate email format
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(email)) {
              setEmailError('Por favor, introduce un email válido')
              return
            }

            if (email && termsAccepted) {
              setIsSubmitting(true)

              try {
                // Save email to Supabase
                const result = await saveEmailToSupabase(email)

                if (result.success) {
                  setSaveSuccess(true)
                  // Redirect to Substack without email parameter
                  window.location.href =
                    'https://conversoriaecnae.substack.com/embed'
                } else {
                  setEmailError(
                    'Error al guardar el email. Por favor, inténtalo de nuevo.'
                  )
                  setIsSubmitting(false)
                }
              } catch (error) {
                console.error('Error in form submission:', error)
                setEmailError(
                  'Error al procesar la solicitud. Por favor, inténtalo de nuevo.'
                )
                setIsSubmitting(false)
              }
            }
          }}
          className='flex flex-col space-y-4'
        >
          <div className='w-full'>
            <input
              type='email'
              name='email'
              placeholder='Tu Email'
              className={`p-3 rounded-md border-2 border-dashed ${
                emailError
                  ? 'border-red-500'
                  : 'border-text-secondary border-border'
              } bg-transparent text-text-primary w-full`}
              required
            />
            {emailError && (
              <p className='text-red-500 text-sm mt-1'>{emailError}</p>
            )}
            {saveSuccess && (
              <p className='text-green-500 text-sm mt-1'>
                Email guardado correctamente
              </p>
            )}
          </div>

          <div className='flex items-start space-x-2'>
            <input
              type='checkbox'
              name='terms'
              id='terms'
              className='mt-1'
              required
            />
            <label htmlFor='terms' className='text-sm text-text-secondary'>
              Estoy de acuerdo con los{' '}
              <a
                href='/terminos-condiciones'
                className='text-primary hover:underline'
              >
                Términos & Condiciones
              </a>
            </label>
          </div>

          <button
            type='submit'
            className='bg-primary hover:bg-primary-dark text-background font-medium py-3 px-6 rounded-md transition duration-300'
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Procesando...' : 'Suscribirme al boletín'}
          </button>
        </form>
      </div>
      <div className='flex items-center justify-center mt-4 text-sm italic text-text-secondary'>
        <span>
          Protegemos tu privacidad. No compartimos tus datos con terceros.
        </span>
      </div>
    </section>
  )
}

export default Newsletter
